module.exports = {
    selectLanguage: 'Sprache:',
    reserve: 'Mehr erfahren',
    close: 'Schließen',
    Title: 'Anrede*',
    Mr: 'Herr',
    Mrs: 'Frau',
    Email: 'E-Mail*',
    Firstname: 'Vorname*',
    Lastname: 'Nachname*',
    Message: 'Mitteilung',
    Checkbox_waitlist:
        'Ja, ich möchte auf die Warteliste. Bitte senden Sie mir weitere Informationen. ',
    Checkbox_updates: 'Ja, ich möchte Updates erhalten.',
    Checkbox_waiting: 'Ja, ich möchte mich für die Warteliste registrieren.',
    Form_GDPR:
        'Mit dem Versand dieses Formulars bestätigen Sie, dass Sie mit den <a href="https://www.andermatt-swissalps.ch/datenschutzerklaerung/" target="_blank">Datenschutzerklärungen</a> einverstanden sind.',
    'Privacy Policy': 'Datenschutzerklärung',
    privacyLink: 'https://www.andermatt-swissalps.ch/datenschutzerklaerung/',
    Submit: 'Absenden',
    Submiting: 'Versand',
    'Title is required': 'Anrede ist erforderlich',
    'First name must be at least 2 characters':
        'Vorname muss mindestens 2 Zeichen lang sein',
    'First name is required': 'Vorname ist erforderlich',
    'Last name is required': 'Nachname ist erforderlich',
    'Last name must be at least 2 characters':
        'Nachname muss mindestens 2 Zeichen lang sein',
    'Invalid email': 'Ungültige E-Mail',
    'Email is required': 'E-Mail ist erforderlich',
    'Message is required': 'Mitteilung ist erforderlich',
    'Download Floorplans': 'Grundrisse herunterladen',
    'Thank you for getting in touch.': 'Vielen Dank für Ihre Kontaktaufnahme.',
    'There was an issue submitting the form.':
        'Beim Senden des Formulars ist ein Problem aufgetreten.',
    'Cookie settings': 'Cookie-Einstellungen',
    CookiesMessage:
        'Die Webseite verwendet Cookies: Cookies helfen uns bei der Bereitstellung unserer Dienste. Durch die Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies setzen. ',
    'Learn more': 'Mehr erfahren',
    CookiesLink: 'https://www.andermatt-swissalps.ch/de/cookies',
    ACCEPT: 'AKZEPTIEREN',
}
